import { render, staticRenderFns } from "./ChatWidget.vue?vue&type=template&id=c8bb4cc0&"
import script from "./ChatWidget.vue?vue&type=script&lang=js&"
export * from "./ChatWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports